import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';

export const createJsonTheme = (readOnly: boolean) =>
  createTheme({
    theme: 'light',
    settings: {
      background: readOnly ? '#F2F2F2' : '#FFF',
      gutterBackground: readOnly ? '#E8E8E8' : '#F5F5F5',
      fontFamily: 'DM Mono',
      fontSize: '12px'
    },
    styles: [
      { tag: t.propertyName, color: '#737373' },
      {
        tag: [t.string, t.number, t.bool, t.null],
        color: '#0D0D0D'
      },
      {
        tag: [t.brace, t.bracket],
        color: '#737373'
      }
    ]
  });
